import { set as setCookie } from 'es-cookie';
import { matchPath } from 'react-router';
import qs from 'qs';

import apiRequestService from 'common/services/api/apiRequestService';
import { Credentials, Method } from 'common/services/http/types';
import {
  COMMON_AFFILIATE_PAGES,
  REGISTRATION_PATH,
} from 'common/selectors/sidebar/common';
import { configFetchSuccessAction } from 'common/actions/config';
import httpRequestService from 'common/services/http/httpRequestService';

const saveAffiliateId = ({ affiliateId }) =>
  setCookie('__scaffid', affiliateId, { expires: 90 });

const middleware =
  ({ getState }) =>
  (next) =>
  (action) => {
    const result = next(action);

    switch (action.type) {
      case configFetchSuccessAction.type: {
        const {
          config,
          router: { location },
        } = getState();
        const query = qs.parse(location.search, { ignoreQueryPrefix: true });

        if (config.user) {
          break;
        }

        if (
          COMMON_AFFILIATE_PAGES.includes(location.pathname) &&
          document.head
        ) {
          document.head.setAttribute(
            'prefix',
            'og: https://ogp.me/ns# fb: https://ogp.me/ns/fb# website: https://ogp.me/ns/website#',
          );
        }

        const match = matchPath<{ userId?: string }>(
          location.pathname,
          `${REGISTRATION_PATH}/:userId?`,
        );

        /**
         * Note for strangers who don't have a clue what's going on here
         *
         * We have 3 (three) ways of referrals tracking mixed up.
         *
         * 1. Invites.
         * Long, long time ago invites were generated in admin panel
         * so every user was able to have as many of them as he want.
         * Example of invite link is `https://stripcash.com/sign-up/{inviteCode}`
         * where {inviteCode} is generated 64 symbols hash.
         * Invite code is supposed to be sent on backend on very last step of registration flow.
         * Easy-peasy.
         *
         * 2. Webmasters impressions / clicks tracking
         * In next iteration webmasters impressions and clicks were added in registration flow.
         * Link was changed in favor of "normal go link" format that contains userId={trackId} query parameter.
         * Tracking was implemented using calling of `userImpressionUrl` and `userClickUrl`.
         * `https://stripcash.com/sign-up/{inviteCode}` url became `https://stripcash.com/sign-up/{inviteCodeOrTrackId}?userId={trackId}`
         * `userClickUrl` returns affiliateId that stored in cookies for 90 days in the same manner as we do it on Stripchat.
         * Not easy but wait for it.
         *
         * 3. Tracking by username or fancy custom string.
         * Affiliate managers wanted a way to use links like `https://stripcash.com/sign-up/bombus` or `https://stripcash.com/sign-up/not-an-ashhhbenn`.
         * So we made up a way to exchange that custom string to trackId. It works in similar way as invites do but with extra exchange step.
         * Legacy invite codes are good for exchanging as well.
         */

        (match?.params?.userId
          ? apiRequestService({
              method: `/users/${match.params.userId}/trackId`,
              httpMethod: Method.Get,
            }).then(({ trackId }) => trackId)
          : Promise.resolve(query.userId)
        ).then((trackId) => {
          if (trackId) {
            httpRequestService({
              host: config.url.userClickUrl.split('//')[1],
              method: Method.Get,
              query: { ...query, userId: trackId },
              credentials: Credentials.Omit,
            }).then(saveAffiliateId);
          } else if (config.referrer === 'https://thecambusiness.com/') {
            httpRequestService({
              host: config.url.userClickUrl.spliT('//')[1],
              method: Method.Get,
              query: {
                sourceId: query.t
                  ? 'thecambusiness-organic'
                  : 'thecambusiness-direct',
              },
            }).then(saveAffiliateId);
          }
        });

        break;
      }
      default:
        break;
    }

    return result;
  };

export default middleware;
